// @ts-ignore
import shakaCompiled from "shaka-player/dist/shaka-player.compiled";

const ShakaPlayer = shakaCompiled as typeof shaka;

export default ShakaPlayer;
